import React, { Component } from 'react'
import {Form,Input,Toast,Button,Select,Loading} from 'element-react';
import QueryStepBar from "../../components/queryStepBar";
import nodataimgurl from "../../assets/nodata@2x.png";
import cusUtilFn from "../../utils/cusUtilFn"
import _hbzwfwJssdk from "../../utils/hbzwfwJssdk"
const hbzwfwJssdk = window.hbzwfwJssdk;
class index extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isEhuiBan:true,
      title:"老年人优待证办理",
      fitrange:"武汉市",
      stepData:['校验信息','提交申请','查看状态'],
      curstep:1, //导航条
      conData:{},
      phone:'',
      maxLength:11,
      value: 0,
      valAvailable:0,//验证
      isloading:true,

      areaAdr1:[],
      areaAdr1Value:null,
      areaAdr2:[],
      areaAdr2Value: null,
      areaAdr3:[],
      areaAdr3Value: null
    }
  }
  componentDidMount() {
    let that=this,res=this.props.location.state;
    if(!!!res) return
    const obj=res;
    let result=obj.resdata.result,
    cardno=obj.resdata.cardno;
    if(result){
      that.setState({
        conData:result,
        cardno:cardno,
        isloading:false
      },()=>{
        that.syncGetArea("4201",(areaInfo)=>{
          that.setState({
            areaAdr1:areaInfo
            })
        });
      })
    }
  }

  //获取下级地区代码
  syncGetArea(parentId,callback){
    let that=this,
     param={
         "parentId": parentId
     }
     _hbzwfwJssdk.requestHeaderNewWork(
      `/96e03b0f1a264e5aa76aa1e49661c7d7`,
      "post",
      {'X-hbzw-Api-Key':'ee49a3c0-31a0-4fa9-b9cc-54306d3b8268'},
      param,
      (res) => {
        let resdata=res.data;
        if(resdata.areaInfo){
          let arr=resdata.areaInfo,resArr=[]
          arr.forEach(element => {
            element.label=element.azaa0002
            element.value=element.azaa0001
            resArr.push(element)
          });
          callback(resArr)
        }
      },
      (error) => {
        console.log(error,"error") 
      }
    )

  }
  //提交
  submit(){
    let that=this,{cardno,areaAdr3Value,phone,valAvailable}=this.state;
    let phoneTip="";
    if(valAvailable===0){
      phoneTip="联系电话不能为空"
    }else if(valAvailable===1){
      phoneTip="联系电话格式错误"
    }else{
      phoneTip=""
    }
    if(!!phoneTip){
      hbzwfwJssdk.notice.prompt({
        isSuccess: 'error',
        prompt_text: "提交失败",
        prompt_text_detail:phoneTip,
        btnArray:[]
      })
      return;}
    if(!areaAdr3Value){
      hbzwfwJssdk.notice.prompt({
        isSuccess: 'error',
        prompt_text: "提交失败",
        prompt_text_detail:"请选择回卡地址",
        btnArray:[]
      })
      return;
    }
    let param={
        cardno: cardno,
        address:areaAdr3Value,
        ec01012:phone,
        sourceType:'9'
    }
    _hbzwfwJssdk.requestHeaderNewWork(
      `/12cd509797324f0d9dec8c1629437fb8`,
      "post",
      {'X-hbzw-Api-Key':'e123408c-7543-4b21-9447-5485dfebf402'},
      param,
      (res) => {
        let resdata=res.data;
        console.log(resdata.issuccess==='0')
        let option={}
        if(resdata.issuccess==='1'){
          option={
            isSuccess: 'success',
            prompt_text: "提交成功",
            prompt_text_detail: '操作成功提示详情',
            btnArray: [
                {
                  btn_text : '返回页面',
                  callBackFunction : function(){
                    //关闭弹框
                    document.getElementsByClassName('prompt-frame-header-clearBox')[0].click();
                  }
                },
                {
                  btn_text : '查看办理信息',
                  callBackFunction :  function(){
                    //关闭弹框
                    document.getElementsByClassName('prompt-frame-header-clearBox')[0].click();
                    let data={
                    resdata:{
                      result:resdata,
                      cardno:cardno
                      }
                    }
                    that.props.history.push({pathname:'/oldmanAccreditZw/result',state:data})
                  }
                }
              ]
          }
        }else if(resdata.issuccess==='0'){
          option={
            isSuccess: 'error',
            prompt_text: "提交失败",
            prompt_text_detail:resdata.errordescription,
            btnArray: [
                {
                  btn_text : '返回页面',
                  callBackFunction : function(){
                    //关闭弹框
                    document.getElementsByClassName('prompt-frame-header-clearBox')[0].click();
                  }
                }
              ]
          }
        }
        hbzwfwJssdk.notice.prompt(option)
      },
      (error) => {
        console.log(error,"error") 
      }
    )
    
  }
  handlePhoneChange=(value)=>{
    let valAvailable=-1,phoneTip='',{maxLength}=this.state;
    if(!value){ //清空操作
      phoneTip=''
    }else{
      value=value.replace(/[^0-9-]+/,'');
      let isTelFirst=value.indexOf("-"),
      valAvailable=-1,
      vallen=value.length;
      if(isTelFirst>-1){
        maxLength=12;
      }else{
        maxLength=11
      }
      if(maxLength===12&&vallen>11){
        valAvailable=cusUtilFn.isFixedTelAvailable(value);
      }else if(maxLength===11&&vallen>10){
        valAvailable=cusUtilFn.isPhoneAvailable(value);
      }
      if(valAvailable===1){
        phoneTip="联系电话格式错误"
      }else{
        phoneTip=""
      }
      if(!!phoneTip){Toast.info(phoneTip)}
    }
    this.setState({
      phone: value,
      maxLength:maxLength
    })
  }
  handlePhoneBlur=(e)=>{
    let valAvailable=-1,value=e.target.value;
    value=value.trim();
    valAvailable=cusUtilFn.isPhoneorFixedTelAvailable(value);
    this.setState({
      phone:value,
      valAvailable:valAvailable
    })
  }
  onChangeareaAdr1 = (areaAdr) => {
    let that=this;
    if(!areaAdr){
      that.syncGetArea("4201",(areaInfo)=>{
        that.setState({
          areaAdr1:areaInfo
          })
      });
    }
    this.syncGetArea(areaAdr,(areaInfo)=>{
      that.setState({
        areaAdr1Value:areaAdr,
        areaAdr2:areaInfo,
        areaAdr2Value:null,
        areaAdr3Value:null,
        areaAdr2Txt:"街道",
        areaAdr3Txt:"社区",
       })
    });
  };
  onChangeareaAdr2 = (areaAdr) => {
    let that=this;
    this.syncGetArea(areaAdr,(areaInfo)=>{
      that.setState({
        areaAdr2Value:areaAdr,
        areaAdr3:areaInfo,
        areaAdr3Value:null,
        areaAdr3Txt:"社区"
       })
    });
  };
  onChangeareaAdr3 = (areaAdr) => {
    this.setState({
      areaAdr3Value: areaAdr,
    });
  };
  render() {
    let that=this,{isEhuiBan,conData,phone,maxLength,isloading,
      areaAdr1,
      areaAdr1Value,
      areaAdr2,
      areaAdr2Value,
      areaAdr3,
      areaAdr3Value}=this.state;
    let DOM = 
    <div className="dataBox">
      <div className="contain"> 
         <div className="formTlt">
            请补充信息提交申请
          </div>
        <div className="formBox">
          <Form
              ref="form"
              labelPosition="left"
              labelWidth="100px"
              className="formDiv"
            >
              <Form.Item
              className="formIpt"
              label="联系电话"

              >  
                <Input
                    maxLength={maxLength}
                    ref="phone"
                    placeholder="请输入联系电话"
                    onChange={(e)=>{this.handlePhoneChange(e)}}
                    onBlur={(e)=>this.handlePhoneBlur(e)}
                  ></Input> 
              </Form.Item>
              <Form.Item
                label="回卡地址"
                className="formSelect"
            >  
                  <Select className="ehb-cpu-react-select" value={areaAdr1Value} placeholder="请选择区域" onChange={this.onChangeareaAdr1}>
                    {
                      areaAdr1.map(el => {
                        return <Select.Option key={el.value} label={el.label} value={el.value}/>
                      })
                    }
                  </Select>
                  <span className="select-gap"></span>
                  <Select className="ehb-cpu-react-select" value={areaAdr2Value} placeholder="请选择街道" onChange={this.onChangeareaAdr2}>
                    {
                      areaAdr2.map(el => {
                        return <Select.Option key={el.value} label={el.label} value={el.value} />
                      })
                    }
                  </Select>
                  <span className="select-gap"></span>
                  <Select className="ehb-cpu-react-select" value={areaAdr3Value} placeholder="请选择社区" onChange={this.onChangeareaAdr3}>
                    {
                      areaAdr3.map(el => {
                        return <Select.Option key={el.value} label={el.label} value={el.value} />
                      })
                    }
                  </Select>
                </Form.Item>
            </Form>
        </div>
        <div className="flexC mt40">
         <Button type="primary" className="cus-btn1" onClick={()=>{this.submit()}}>提交申请</Button> 
        </div>

        <div className="mt40">
        <Loading loading={isloading}>
          <table className="el-table cus-table">
          <tbody>
            <tr>
              <th><div className="cell">姓 名</div></th>
              <td><div className="cell">{cusUtilFn.hideByplusXing(conData.name,0,1)}</div></td>
              <th><div className="cell">性 别</div></th>
              <td><div className="cell">{conData.gender==="1"?'男':'女'}</div></td>
            </tr>
            <tr>
              <th><div className="cell">居住地社区</div></th>
              <td><div className="cell">{conData.ec01005_desc}</div></td>
              <th><div className="cell">户籍地社区</div></th>
              <td><div className="cell">{conData.ec01004_desc}</div></td>
            </tr>
            </tbody>
          </table>
          </Loading>
        </div>


     </div>
    </div>
    return (
      <div className="cusStl oldmanAccredit w-auto">
         <div className="navBar">
            <div className="navBar_text"> {this.state.title}</div>
        </div>
        <QueryStepBar datas={this.state.stepData} curstep={this.state.curstep}/>

        {!!conData?DOM:(
          <div className="noDataBox">
            <div className="nodataTip">
            <img src={nodataimgurl}></img>
            <span>暂未查询到您的信息，请确认后重试</span>
            </div>

            <div className="despBox">
            <div className="despTtl">
            服务说明：
            </div>
            <div className="despTxt">
              1、老年人优待证权益同老年证相同<br></br>
              2、老年人优待证的办理对象为具有武汉市户籍且年满60周岁的老年人，或在武汉市常住且取得了《武汉市居民证》年满60周岁的老年人<br></br>
              3、此次查询是查询您的备案信息，如未查询到您的信息，请确认您的身份证号是否正确或是否具备办理条件，如非以上原因，请联系当地街道办事处或政务中心<br></br>
              4、本服务目前仅支持新证办理，如需补办请前往当地街道办事处或政务中心<br></br>
              5、如有疑问请联系客服处理<br></br>
            </div>
            </div>
          </div>)
        }
     
     
      </div>
    )

  }
}

export default index